import { useEffect, useState } from 'react';

export function useIsMobile() {
    const [isMobile, setIsMobile] = useState<boolean | undefined>(undefined);

    useEffect(() => {
        const userAgent = navigator.userAgent;
        setIsMobile(/mobile/i.test(userAgent));
    }, []);

    return isMobile;
}
